var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37508 9.89771C2.56413 8.09302 1.19181 5.91235 1.19181 4.11393C1.19181 3.31811 1.46126 2.59749 2.06909 2.01473C2.4388 1.65755 2.86491 1.46956 3.27848 1.46956C3.61686 1.46956 3.92391 1.60116 4.14323 1.90194L5.49048 3.80062C5.69727 4.09513 5.80379 4.33952 5.80379 4.5651C5.80379 4.85335 5.6346 5.104 5.35889 5.39225L4.91398 5.84969C4.84505 5.91862 4.81999 6.00008 4.81999 6.08154C4.81999 6.17554 4.85759 6.26326 4.88892 6.33219C5.08944 6.7207 5.65967 7.38493 6.27376 7.99902C6.89412 8.61312 7.55835 9.18335 7.94686 9.39014C8.00952 9.42147 8.10352 9.45907 8.19751 9.45907C8.27897 9.45907 8.3667 9.42773 8.43563 9.35881L8.88053 8.92017C9.16878 8.63818 9.4257 8.47526 9.70768 8.47526C9.93327 8.47526 10.1777 8.57552 10.4722 8.77604L12.3959 10.1421C12.6904 10.3551 12.8095 10.6559 12.8095 10.9692C12.8095 11.3953 12.6027 11.8277 12.2706 12.1974C11.7004 12.8241 10.9923 13.106 10.1839 13.106C8.3855 13.106 6.18604 11.7087 4.37508 9.89771Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilled);
export default __webpack_public_path__ + "static/media/phone-filled.fa3199cecc98bf0acc761654d7a0e757.svg";
export { ForwardRef as ReactComponent };